import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TFacilityForm, TVariantForm } from "redux/reducers/models/facility";

type TGetFacilityForm = {
  id?: string | number;
  variant_ids?: Array<number>;
};

// GET Forms
export async function GetFacilityForm(params: TGetFacilityForm, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TFacilityForm[]>(APIUrl(AdminType.ClientAdmin, "/client/form"), params, useGlobalLoader, token);
}
